module.exports = __webpack_public_path__ + "static/media/texture_01.11f1bb3e.png";